import $ from 'jquery';
import {gsap, Power4} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

let carouselProperties = {
    init() {
        if (!$('.carousel-properties-desktop').length) return;
        $('.carousel-properties-desktop').each((index, element) => {
            this.initAnimation(element);
        });
    },
    initAnimation(element) {
        const slidesCount = $(element).find('.carousel-property').length;
        let prevSlide = 0;
        $(element).find('.carousel-property:nth-child(1)').addClass('is-active');
        const timeline = gsap.timeline({
            defaults: {
                overwrite: "auto",
                ease: "power1"
            },
            scrollTrigger: {
                end: `+=${slidesCount * 80}%`,
                pin: true,
                pinSpacing: true,
                scrub: true,
                start: "top top+=55px",
                trigger: element,
                onUpdate: (self) => {
                    const progress = self.progress.toFixed(2);
                    let currentSlide = Math.round(progress * slidesCount) + 1;
                    if(currentSlide > slidesCount) currentSlide = slidesCount;
                    const $currentSlide = $(element).find('.carousel-property:nth-child(' + currentSlide + ')');
                    $(element).find('.carousel-property:nth-child(' + currentSlide + ')').addClass('is-active').siblings().removeClass('is-active');
                    if(currentSlide != prevSlide) {
                        gsap.to('.box-app-properties__inner__octagon', {
                            rotation:currentSlide * 50,
                            duration:0.2,
                            ease:'linear',
                        })
                        const data_value = $currentSlide.data('value');
                        const data_label = $currentSlide.data('label');
                        $('.box-app-properties__info__label').fadeOut(100);
                        $('.box-app-properties__info__value').fadeOut(100,function() {
                            $('.box-app-properties__info__value').html(data_value);
                            $('.box-app-properties__info__label').html(data_label);
                            $('.box-app-properties__info__value').fadeIn(300);
                            $('.box-app-properties__info__label').fadeIn(300);
                        });
                    }
                    prevSlide = currentSlide;
                }
            }
        });


    },
}

export default carouselProperties;